module.exports = __webpack_public_path__ + "static/media/zayavka_mobile.06856063.png";